import React from 'react';
import { About } from '../components/About';
import { Quote } from 'lucide-react';
export function AboutPage() {
  return <div className="pt-32" data-id="element-167">
      <About data-id="element-168" />

      <section className="py-24 bg-white" data-id="element-169">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
          <div className="relative text-center" data-id="element-171">
            <Quote className="w-16 h-16 text-blue-100 absolute -top-8 -left-8 -z-10" data-id="element-172" />
            <h2 className="text-3xl font-bold text-slate-900 mb-8 italic" data-id="element-173">
              "At AMO Wheelchair Transportation Services, we don’t just provide
              rides — we deliver peace of mind and freedom of movement."
            </h2>
            <div className="w-20 h-1 bg-blue-600 mx-auto mb-8" data-id="element-174" />
            <p className="text-slate-600 text-lg leading-relaxed mb-8" data-id="element-175">
              Founded with a deep commitment to accessibility and dignity, AMO
              provides non-emergency transportation solutions tailored to our
              clients’ needs. We understand that reliability matters —
              especially when it comes to healthcare and daily living — which is
              why we prioritize punctuality, clear communication, and flexible
              scheduling.
            </p>
            <p className="text-slate-600 text-lg leading-relaxed" data-id="element-176">
              Your independence and dignity are our top priorities. We are proud
              to be a part of the Charlotte community, helping our neighbors
              live full, connected lives.
            </p>
          </div>
        </div>
      </section>
    </div>;
}